
import InView from "@/components/devTools/inView";

export default {
  components: { InView },
  data() {
    return {
      visible: false,
    };
  },
};
